import React from 'react';
import { Grid, Button, Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { format } from 'date-fns';

const TimeSlotGrid = ({ timeSlots, selectedTime, onTimeSelect }) => {
  return (
    <Grid container spacing={2}>
      {timeSlots.map((slot, index) => {
        const isSelected = selectedTime === slot;
        
        return (
          <Grid item xs={6} sm={4} md={3} key={index}>
            <Button
              fullWidth
              variant={isSelected ? "contained" : "outlined"}
              onClick={() => onTimeSelect(slot)}
              sx={{
                height: '48px',
                borderColor: isSelected ? 'transparent' : 'primary.main',
                color: isSelected ? 'white' : 'text.primary',
                '&:hover': {
                  borderColor: isSelected ? 'transparent' : 'primary.main',
                  backgroundColor: isSelected 
                    ? 'primary.dark'
                    : 'action.hover',
                },
                transition: 'all 0.2s',
              }}
            >
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                whiteSpace: 'nowrap',
              }}>
                <AccessTimeIcon sx={{ fontSize: 18 }} />
                <Typography variant="body2" noWrap>
                  {slot}
                </Typography>
              </Box>
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TimeSlotGrid; 